var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3.34912,
    y: 23.5216,
    width: 45.7199,
    height: 45.7199,
    rx: 10,
    transform: "rotate(-35.9958 -3.34912 23.5216)",
    fill: "#0FAA8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonGreen);
export default __webpack_public_path__ + "static/media/polygon-green.123b24543b3d5341af91935c95679524.svg";
export { ForwardRef as ReactComponent };